<template>
  <v-container>
    <v-card>
      <v-container>
        <v-row align="center" class="py-1 px-2" no-gutters>
          <v-col cols="12" sm="6">
            <v-breadcrumbs
              class="px-2"
              :items="breadcrumbsItems"
            ></v-breadcrumbs>
          </v-col>
          <v-col
            cols="12"
            sm="6"
            :class="
              $store.getters.LANGUAGE == 'fa' ? 'text-left' : 'text-right'
            "
          >
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  fab
                  small
                  class="mx-2"
                  v-bind="attrs"
                  v-on="on"
                  color="orange"
                  @click="helpDialog = true"
                >
                  <v-icon small>fa-question</v-icon>
                </v-btn>
              </template>
              <span>{{ $vuetify.lang.translator("showHelp") }}</span>
            </v-tooltip>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <div v-bind:style="styleObject">
              <l-map
                ref="myMap"
                :options="mapOptions"
                :zoom="zoom"
                :center="center"
                @ready="updateMap"
                style="z-index:1;"
              >
                <l-tile-layer :url="url" :attribution="attribution" />
                <l-control-zoom
                  position="topleft"
                  :zoomInTitle="$vuetify.lang.translator('zoomIn')"
                  :zoomOutTitle="$vuetify.lang.translator('zoomOut')"
                ></l-control-zoom>
                <l-control-fullscreen
                  position="topleft"
                  :options="{
                    title: {
                      false: $vuetify.lang.translator('fullscreen'),
                      true: $vuetify.lang.translator('normal')
                    }
                  }"
                />
                <l-control-scale
                  position="bottomleft"
                  :imperial="false"
                  :metric="true"
                ></l-control-scale>
                <l-marker
                  v-for="item in towers"
                  :key="item.code"
                  :lat-lng="item.position"
                  @click="showTowerPDF(item.code, item.name)"
                >
                  <l-tooltip
                    :options="{ direction: 'center' }"
                    class="vazir-font"
                    >{{ item.name }} ({{ item.code }})<br />{{
                      $vuetify.lang.translator("normal")
                    }}: {{ item.type1 }}<br />{{
                      $vuetify.lang.translator("warning")
                    }}: {{ item.type2 }}<br />{{
                      $vuetify.lang.translator("critical")
                    }}:
                    {{ item.type3 }}
                  </l-tooltip>
                  <l-icon :icon-anchor="[25, 45]" class-name="tower-label">
                    <img src="/static/img/transmission-tower.png" />
                    <div class="vazir-font">
                      <span style="color: yellow;">{{ item.type1 }}</span> |
                      <span style="color: orange;">{{ item.type2 }}</span> |
                      <span style="color: red;">{{ item.type3 }}</span>
                    </div>
                  </l-icon>
                </l-marker>
                <l-polyline
                  :lat-lngs="latlangs"
                  :color="lineColor"
                ></l-polyline>
              </l-map>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </v-card>

    <v-dialog
      v-model="reportDialog"
      persistent
      max-width="800"
      @keydown.esc="reportDialog = false"
    >
      <v-card>
        <v-toolbar dense elevation="2">
          <v-toolbar-title>{{ dialogTitle }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn icon @click="reportDialog = false">
              <v-icon>fa-times</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-container>
          <v-row>
            <v-col>
              <h3>{{ $vuetify.lang.translator("summaryErrors") }}</h3>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              {{ abstract }}
            </v-col>
          </v-row>
          <v-divider></v-divider>
          <v-row v-for="(item, index) in reportFolders" :key="index">
            <v-col>
              <h3>{{ item.errors }}</h3>
              <v-img :src="item.image"></v-img>
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="reportPDFDialog"
      persistent
      fullscreen
      @keydown.esc="reportPDFDialog = false"
    >
      <v-card>
        <v-toolbar dense elevation="2">
          <v-toolbar-title>{{ dialogTitle }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn icon @click="reportPDFDialog = false">
              <v-icon>fa-times</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-container>
          <v-progress-linear
            indeterminate
            v-if="waitForReport"
          ></v-progress-linear>
          <iframe height="2100px" width="100%" :src="pdfFile" v-else></iframe
        ></v-container>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="helpDialog"
      persistent
      max-width="800"
      @keydown.esc="helpDialog = false"
      transition="dialog-top-transition"
    >
      <v-card>
        <v-toolbar dense elevation="2">
          <v-toolbar-title>{{
            $vuetify.lang.translator("help")
          }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn icon @click="helpDialog = false">
              <v-icon>fa-times</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-card-text>
          <div
            class="mt-6"
            v-html="$vuetify.lang.translator('reportOnMapHelp')"
          ></div>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn color="success" @click="helpDialog = false">{{
            $vuetify.lang.translator("gotIt")
          }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { handleError } from "@/helpers/helper";
import { latLng, Icon } from "leaflet";
import {
  LMap,
  LTileLayer,
  LMarker,
  LTooltip,
  LIcon,
  LControlScale,
  LControlZoom,
  LPolyline
} from "vue2-leaflet";
import LControlFullscreen from "vue2-leaflet-fullscreen";

delete Icon.Default.prototype._getIconUrl;
Icon.Default.mergeOptions({
  iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
  iconUrl: require("leaflet/dist/images/marker-icon.png"),
  shadowUrl: require("leaflet/dist/images/marker-shadow.png")
});

export default {
  name: "ReportOnMap",
  components: {
    LMap,
    LTileLayer,
    LMarker,
    LTooltip,
    LIcon,
    LControlScale,
    LControlZoom,
    LControlFullscreen,
    LPolyline
  },
  data: () => ({
    breadcrumbsItems: [],
    loading: true,
    waitForReport: false,
    report_id: 0,
    report_name: "",
    mapOptions: {
      zoomControl: false,
      zoomSnap: 0.5
    },
    zoom: 14,
    center: latLng(0, 0),
    url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
    attribution:
      '<a href="http://virakavir.com" target="_blank">ViraKavir</a> | &copy; <a href="http://osm.org/copyright" target="_blank">OpenStreetMap</a>',
    styleObject: {
      width: "100%",
      height: "450px"
    },
    towers: [],
    latlangs: [],
    helpDialog: false,
    reportDialog: false,
    dialogTitle: "",
    reportFolders: [],
    abstract: "",
    lineColor: "black",
    pdfFile: null,
    reportPDFDialog: false
  }),
  created() {
    this.report_id = this.$route.params.id;
    this.report_name = this.$route.params.name;

    this.breadcrumbsItems.push({
      text: this.$vuetify.lang.translator("dashboard"),
      to: { name: "Dashboard" }
    });
    this.breadcrumbsItems.push({
      text: this.$vuetify.lang.translator("reports"),
      to: { name: "Reports" }
    });
    this.breadcrumbsItems.push({ text: this.report_name });
    this.breadcrumbsItems.push({
      text: this.$vuetify.lang.translator("map"),
      to: {
        name: "ReportOnMap",
        params: { id: this.report_id, name: this.report_name }
      }
    });
    this.checkPrivileges();
    this.showMap();
  },
  methods: {
    checkPrivileges() {
      let userType = parseInt(this.$store.getters.USERTYPE);
      let allowed_privileges = [1, 2, 3, 4, 6, 7];
      if (allowed_privileges.indexOf(userType) === -1) {
        this.$router.push({ name: "Error403" });
      }
    },
    updateMap() {
      setTimeout(() => {
        this.$refs.myMap.mapObject.invalidateSize();
      }, 100);
    },
    showMap() {
      var self = this;
      this.$http
        .get("/report/" + this.report_id + "/map/")
        .then(function(response) {
          self.lineColor = response.data.line_color;
          let towers = response.data.towers;
          for (var id in towers) {
            let tower = towers[id];
            self.towers.push({
              id: id,
              code: tower.code,
              name: tower.name,
              type1: tower.type1,
              type2: tower.type2,
              type3: tower.type3,
              position: [tower.lat, tower.lon]
            });
            self.latlangs.push([tower.lat, tower.lon]);
          }
          self.center = latLng(self.latlangs[0][0], self.latlangs[0][1]);
        })
        .catch(function(error) {
          let result = handleError(
            error,
            self.$toasted,
            self.$router,
            self.$store
          );
          for (var item in result) {
            self.$toasted.error(result[item], {
              duration: 5000,
              keepOnHover: true,
              className:
                self.$store.getters.LANGUAGE == "fa"
                  ? "vazir-font-fd"
                  : "vazir-font",
              iconPack: "fontawesome",
              icon: "exclamation-triangle",
              position: "top-center"
            });
          }
        });
    },
    showTowerDetail(code, name) {
      this.$toasted.info(
        this.$vuetify.lang.translator("receivingInformation"),
        {
          duration: 5000,
          keepOnHover: true,
          className:
            this.$store.getters.LANGUAGE == "fa"
              ? "vazir-font-fd"
              : "vazir-font",
          iconPack: "fontawesome",
          icon: "spinner",
          position: "top-center"
        }
      );
      this.dialogTitle = "";
      this.abstract = "";
      this.reportFolders = [];
      this.waitForReport = true;
      var self = this;
      this.$http
        .get("/report/" + this.report_id + "/" + code + "/tower/")
        .then(function(response) {
          for (var twr in response.data) {
            let i;
            for (var fld in response.data[twr].folders) {
              let imagesObj = response.data[twr].folders[fld];
              i = 1;
              for (var img in imagesObj) {
                let errors_arr = imagesObj[img]["errors"];
                let errors_text = fld + i + ". ";
                for (var e in errors_arr) {
                  errors_text += errors_arr[e] + " ";
                }
                self.$http
                  .get("/image/" + img + "/small/")
                  .then(function(response) {
                    let result = "data:image/jpg;base64,".concat(response.data);
                    self.reportFolders.push({
                      image: result,
                      errors: errors_text
                    });
                  })
                  .catch(function(error) {
                    let result = handleError(
                      error,
                      self.$toasted,
                      self.$router,
                      self.$store
                    );
                    for (var item in result) {
                      self.$toasted.error(result[item], {
                        duration: 5000,
                        keepOnHover: true,
                        className:
                          self.$store.getters.LANGUAGE == "fa"
                            ? "vazir-font-fd"
                            : "vazir-font",
                        iconPack: "fontawesome",
                        icon: "exclamation-triangle",
                        position: "top-center"
                      });
                    }
                  });
                i++;
              }
            }
            i = 1;
            for (var err in response.data[twr].errors) {
              self.abstract += i + ". " + response.data[twr].errors[err] + " ";
              i++;
            }
          }
          self.dialogTitle = self.$vuetify.lang.translator(
            "reportOfCode",
            name,
            code
          );
          self.$toasted.clear();
          self.reportDialog = true;
        })
        .catch(function(error) {
          let result = handleError(
            error,
            self.$toasted,
            self.$router,
            self.$store
          );
          for (var item in result) {
            self.$toasted.error(result[item], {
              duration: 5000,
              keepOnHover: true,
              className:
                self.$store.getters.LANGUAGE == "fa"
                  ? "vazir-font-fd"
                  : "vazir-font",
              iconPack: "fontawesome",
              icon: "exclamation-triangle",
              position: "top-center"
            });
          }
        })
        .then(function() {
          self.waitForReport = false;
        });
    },
    showTowerPDF(code, name) {
      this.dialogTitle = this.$vuetify.lang.translator(
        "reportOfCode",
        name,
        code
      );
      this.waitForReport = true;
      this.reportPDFDialog = true;
      var self = this;
      this.$http
        .get("/report/" + this.report_id + "/" + code + "/tower/pdf/", {
          responseType: "blob"
        })
        .then(function(response) {
          //Create a Blob from the PDF Stream
          const file = new Blob([response.data], { type: "application/pdf" });
          //Build a URL from the file
          self.pdfFile = URL.createObjectURL(file);
          //Open the URL on new Window
          // window.open(self.pdfFile);
        })
        .catch(function(error) {
          let result = handleError(
            error,
            self.$toasted,
            self.$router,
            self.$store
          );
          for (var item in result) {
            self.$toasted.error(result[item], {
              duration: 5000,
              keepOnHover: true,
              className:
                self.$store.getters.LANGUAGE == "fa"
                  ? "vazir-font-fd"
                  : "vazir-font",
              iconPack: "fontawesome",
              icon: "exclamation-triangle",
              position: "top-center"
            });
          }
        })
        .then(function() {
          self.waitForReport = false;
        });
    }
  }
};
</script>

<style>
.tower-label {
  background-color: rgba(253, 253, 253, 0.7);
  padding: 2px;
  box-shadow: 5px 3px 10px rgba(0, 0, 0, 0.2);
  text-align: center;
  width: auto !important;
  height: auto !important;
  font-weight: 700;
  border-radius: 5px;
}
</style>
